import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Alert, Box, Button, CircularProgress, TextField, Typography,
} from "@mui/material";
import axios from "axios";

function TestNotifications({ env }) {
  const [phone,   setPhone]   = useState("");
  const [email,   setEmail]   = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [result,  setResult]  = useState(null);
  const [error,   setError]   = useState("");

  if (env === "prod") {
    return (
      <Box sx={{ maxWidth: 540 }}>
        <Alert severity="error">Not available in production.</Alert>
      </Box>
    );
  }

  const send = () => {
    if (!phone && !email) {
      setError("Enter a phone number and/or an email address to test.");
      return;
    }
    setError("");
    setResult(null);
    setSending(true);
    axios
      .post("/api/dev-tools/test-notification", {
        phone: phone || undefined,
        email: email || undefined,
        message: message || undefined,
      })
      .then(({ data }) => setResult(data))
      .catch((e) => setError(e?.response?.data || "Failed to send test notification."))
      .finally(() => setSending(false));
  };

  return (
    <Box sx={{ maxWidth: 540 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: .5 }}>Test Notifications (Dev)</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Sends a real SMS and/or email through the live gateways so you can confirm delivery is
        actually working. Only available outside production.
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {result?.sms && (
        <Alert severity={result.sms.ok ? "success" : "error"} sx={{ mb: 2 }}>
          SMS: {result.sms.ok ? "sent" : `failed — ${JSON.stringify(result.sms.error)}`}
        </Alert>
      )}
      {result?.email && (
        <Alert severity={result.email.ok ? "success" : "error"} sx={{ mb: 2 }}>
          Email: {result.email.ok ? "sent" : `failed — ${result.email.error}`}
          {result.email.note ? ` (${result.email.note})` : ""}
        </Alert>
      )}

      <TextField
        label="Phone number"
        size="small"
        fullWidth
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="e.g. 07XXXXXXXX"
        sx={{ mb: 2 }}
      />
      <TextField
        label="Email address"
        size="small"
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="e.g. you@example.com"
        sx={{ mb: 2 }}
      />
      <TextField
        label="Message (optional)"
        size="small"
        fullWidth
        multiline
        minRows={2}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Defaults to a timestamped test message"
        sx={{ mb: 3 }}
      />

      <Button
        variant="contained"
        color="warning"
        onClick={send}
        disabled={sending}
        startIcon={sending ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {sending ? "Sending…" : "Send test"}
      </Button>
    </Box>
  );
}

const mapStateToProps = ({ env }) => ({ env });

export default connect(mapStateToProps)(TestNotifications);
